module.exports = __webpack_public_path__ + "static/testimonial2-9177cde79dd202abfa7ae96644dfc821.png";